
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RouteCardInfo",
  components: {
    Button,
    Skeleton,
  },
  props: ["order", "flightId"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const routeRules = ref(null);
    const getRouteInfo = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetFlightRuleInfo?guid=${props.order}&flightId=${props.flightId}`
        );
        let fetchedPass = await json.data;
        routeRules.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      routeRules,
      getRouteInfo,
    };
  },
  data() {
    return {
      hoursWords: ["час", "часа", "часов"],
      minutesWords: ["минута", "минуты", "минут"],
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getHoursTimeInFlight(time: any) {
      let flightHours = 0;
      let splited = time.split(":");
      flightHours += +splited[0];
      return flightHours;
    },
    getMinutesTimeInFlight(time: any) {
      let flightMinutes = 0;
      let splited = time.split(":");
      flightMinutes += +splited[1];
      return flightMinutes;
    },
    declOfHours(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    getAnyDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getTransportInfo(item: any) {
      if (item.Id === 7) {
        return "в пути на автобусе";
      } else if (item.Id === 436) {
        return "в пути на поезде";
      } else {
        return "в полёте на " + item.NameRus;
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getRouteInfo();
  },
});
